// @flow
import React, { useContext } from 'react';
import * as yup from 'yup';

import { t } from 'Src/i18n';
import ReactAppContext from 'Context/ReactAppContext';

import { GridRow as Row } from 'Components/frameworks/grid-row/Grid.row.jsx';
import { GridCell as Cell } from 'Components/frameworks/grid-cell/Grid.cell.jsx';
import { FormikInput } from 'Components/frameworks/formik/FormikInput.jsx';

const CELL_GRID_ONE_THIRD = { M: 4 };

export const subscriptionSchema = () =>
  yup.object().shape({
    civility: yup.string().required(t('common.form.errors.requiredField')),
    firstName: yup
      .string()
      .max(
        20,
        t('common.form.errors.fieldTooLong', {
          label: t('memberSpace.profile.firstName'),
          maxlength: 20,
        }),
      )
      // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
      .matches(
        /^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/,
        t('common.form.errors.noSpecialCharsField'),
      )
      .required(t('common.form.errors.requiredField')),
    lastName: yup
      .string()
      .max(
        30,
        t('common.form.errors.fieldTooLong', {
          label: t('memberSpace.profile.lastName'),
          maxlength: 30,
        }),
      )
      // regex to validate first / last name - no special characters, only letters, dashes, dots or apostrophs are allowed
      .matches(
        /^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/,
        t('common.form.errors.noSpecialCharsField'),
      )
      .required(t('common.form.errors.requiredField')),
    unicodeFirstName: yup.string().max(100),
    unicodeLastName: yup.string().max(100),
    email: yup
      .string()
      .email(t('common.form.errors.invalidEmailField'))
      .required(t('common.form.errors.requiredField')),
  });

export function NewsletterForm() {
  const appContext = useContext(ReactAppContext);

  return (
    <React.Fragment>
      <Row className="mt-4 md:mt-0" hasTopGutters={false}>
        <Cell cols={CELL_GRID_ONE_THIRD}>
          <FormikInput
            name="civility"
            type="select"
            isRequired
            label={t('memberSpace.profile.civility')}
            options={[
              {
                name: t('memberSpace.profile.civility'),
                value: '',
                isDisabled: true,
              },
              {
                name: t('newsletter.signup.civilityMale'),
                value: 'M',
              },
              {
                name: t('newsletter.signup.civilityFemale'),
                value: 'F',
              },
            ]}
          />
        </Cell>
        <Cell className="mt-4 md:mt-0" cols={CELL_GRID_ONE_THIRD}>
          <FormikInput
            name="firstName"
            isRequired
            label={t('memberSpace.profile.firstName')}
            type="text"
            placeholder={t('memberSpace.profile.firstName')}
          />
        </Cell>
        <Cell className="mt-4 md:mt-0" cols={CELL_GRID_ONE_THIRD}>
          <FormikInput
            name="lastName"
            isRequired
            label={t('memberSpace.profile.lastName')}
            type="text"
            placeholder={t('memberSpace.profile.lastName')}
          />
        </Cell>
      </Row>
      {appContext.displayUnicodeFields && (
        <Row className="mt-4" hasTopGutters={false}>
          <Cell offsets={CELL_GRID_ONE_THIRD} cols={CELL_GRID_ONE_THIRD}>
            <FormikInput
              name="unicodeFirstName"
              label={t('memberSpace.profile.unicodeFirstName')}
              type="text"
              placeholder={t('memberSpace.profile.unicodeFirstName')}
            />
          </Cell>
          <Cell className="mt-4 md:mt-0" cols={CELL_GRID_ONE_THIRD}>
            <FormikInput
              name="unicodeLastName"
              label={t('memberSpace.profile.unicodeLastName')}
              type="text"
              placeholder={t('memberSpace.profile.unicodeLastName')}
            />
          </Cell>
        </Row>
      )}
      <Row className="mt-4" hasTopGutters={false}>
        <Cell cols={{ M: 12 }}>
          <FormikInput
            name="email"
            isRequired
            type="email"
            placeholder={t('memberSpace.profile.email')}
            label={t('memberSpace.profile.email')}
            labelAdditionalInfo={t('memberSpace.profile.additionalInfoEmail')}
          />
        </Cell>
      </Row>
    </React.Fragment>
  );
}
